import React from "react";
import { StaticQuery, graphql } from "gatsby";
import Helmet from "react-helmet";
import PropTypes from "prop-types";
import Clock from "react-clock";
import Calendar from "react-calendar";

// Import global styles
import "normalize.css";
import "../assets/styles/globalStyles.scss";
import "../assets/styles/widgetStyles.scss";

import styles from "../assets/styles/HomeLayout.module.scss";

import HomeNavigation from "./HomeNavigation";

class HomeLayout extends React.Component {
	constructor(props) {
		super(props);

		this.state = { time: new Date(), calendar: new Date() };
	}

	componentDidMount() {
		setInterval(() => this.setState({ time: new Date() }), 1000);
	}

	onChange = calendar => this.setState({ calendar });

	render() {
		return (
			<StaticQuery
				query={graphql`
					query SiteTitleQuery {
						site {
							siteMetadata {
								title
							}
						}
					}
				`}
				render={data => {
					const title = data.site.siteMetadata.title;

					return (
						<div className={styles.root}>
							<Helmet htmlAttributes={{ lang: "en" }} defaultTitle={title} />

							<nav className={styles.navigation}>
								<HomeNavigation />
							</nav>
							<main className={styles.content}>{this.props.children}</main>
							<div className={styles.widgets}>
								<Clock value={this.state.time} />
								<Calendar
									value={this.state.calendar}
									onChange={this.onChange}
								/>
							</div>
						</div>
					);
				}}
			/>
		);
	}
}

HomeLayout.propTypes = {
	children: PropTypes.node.isRequired
};

export default HomeLayout;
